@if (currentSubscription(); as subscription) {
<div>
	@if (subscription) {
	<lib-card [title]="'Manage your subscription'" [subtitle]="'Status: ' + subscription.status">
		<div [libFlexRow]="isMobileView()" [libFlexRowAlign]="'start'" [libFlexRowGap]="'16px'">
			@if (subscription.status === 'active') {
			<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
				<lib-link
					[linkStyle]="'noUnderline'"
					[externalUrl]="subscription.paymentUpdateUrl"
					[routerLink]="undefined"
				>
					<lib-button [buttonType]="'basic'">Update payment</lib-button>
				</lib-link>
			</div>
			<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
				<lib-link
					[linkStyle]="'noUnderline'"
					[externalUrl]="subscription.cancelationUrl"
					[routerLink]="undefined"
				>
					<lib-button [buttonType]="'delete'">Cancel</lib-button>
				</lib-link>
			</div>
			} @else if (subscription.status === 'canceled'){
			<span>Your subscription has been canceled</span>
			}
		</div>
	</lib-card>
	} @else {
	<lib-message [type]="'success'">You already have license '{{ authUser()?.license }}' activated </lib-message>
	}
</div>
}

<lib-card
	[cardIcon]="'purchase'"
	[class.push-top-md]="currentSubscription() ? true : false"
	[title]="'Create new subscription'"
>
	<div [className]="paddleContainerClassName"></div>
</lib-card>

<lib-card class="push-top-md" [cardIcon]="'info'">
	<h4>Not happy with the product?</h4>
	<div class="push-top-sm">
		Request a full refund within 30 days of your purchase. To request a refund please send us an e-mail at
		<a [href]="refundHref">{{ refundEmail }}</a>
	</div>
</lib-card>
